module.exports = __webpack_public_path__ + "static/img/logo_shcszwy.ebb0782.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/logo_shcszwy.png
// module id = XV4Z
// module chunks = 15